// ---------------- DEVELOPMENT: LOCAL MACHINE. ----------------

// import axios from "axios";

// export const makeRequest = axios.create({
//   baseURL: "http://localhost:8800/api/",
//   withCredentials: true,
// });

// ---------------- DEPLOYMENT: RAILWAY: Backend API Service URL ----------------

import axios from "axios";

export const makeRequest = axios.create({
  baseURL: "https://api-production-54c8.up.railway.app/api/",
  withCredentials: true,
});



